/**
 * Copy to clipboard button component
 */
import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { copyToClipboard } from '@/utils/clipboard';
import { toast } from 'react-toastify';

interface CopyButtonProps {
  text: string;
  label?: string;
  size?: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: 'icon-sm',
  medium: 'icon',
  large: 'icon-lg',
} as const;

export const CopyButton: React.FC<CopyButtonProps> = ({ text, label = 'Copy', size = 'medium' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const success = await copyToClipboard(text);
    if (success) {
      setCopied(true);
      toast.success(`${label} copied to clipboard!`);
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast.error('Failed to copy to clipboard');
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size={sizeMap[size] as 'icon-sm' | 'icon' | 'icon-lg'}
          onClick={handleCopy}
          className={copied ? 'text-success' : ''}
        >
          {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{copied ? 'Copied!' : label}</TooltipContent>
    </Tooltip>
  );
};
